var doVideo = {
    init : function() {
        if (wayData.hasOwnProperty("video") && video) {
            video.play(wayData.video, function() {
                game.states.setState("QUESTIONS");
            }.bind(this));
        } else {
            video.play("placeholder.m4v", function() {
                game.states.setState("QUESTIONS");
            }.bind(this));
        }
    },
    update : function(delta) {
    },
    
    shutDown : function() {
    }
}

